<span class="flight-status submitted" *ngIf="creativeStatusId === eCreativeStatus.Submitted && (campaignType !== eAccountType.FAN365 && campaignType !== eAccountType.OAS)">
  Submitted
</span>

<span class="flight-status submitted" *ngIf="creativeStatusId === eCreativeStatus.Re_Submitted && (campaignType !== eAccountType.FAN365 && campaignType !== eAccountType.OAS)">
  Resubmitted
</span>

<span class="flight-status pending" *ngIf="creativeStatusId === eCreativeStatus.Pending_Submission && (campaignType !== eAccountType.FAN365 && campaignType !== eAccountType.OAS)">
  <i class="pi pi-clock"></i>
  Pending Submission
</span>

<span class="flight-status modified" *ngIf="(creativeStatusId === eCreativeStatus.Modified || creativeStatusId === eCreativeStatus.Re_Modified)  && (campaignType !== eAccountType.FAN365 && campaignType !== eAccountType.OAS)">
  <span class="w-2 h-2 bg-amber-400 rounded-full"></span>
  Modified
</span>

<span *ngIf="getFlightCreativeBuildStatus() as status" class="flight-status build-sent m-2">
        <i class="pi pi-bolt build-icon"></i>
    {{ status }}
</span>

<div *ngIf="(creativeStatusId === eCreativeStatus.Modified || creativeStatusId === eCreativeStatus.Re_Modified) && (campaignType !== eAccountType.FAN365 && campaignType !== eAccountType.OAS)">
  <div class="flight-warning inline-flex items-center gap-2">
    <i class="pi pi-exclamation-circle"></i>
    <span> Changes saved but not resubmitted </span>
  </div>
</div>
